module.exports = __webpack_public_path__ + "img/personal sales.2d38376a.svg";